import {
  MARKETING_CONSENT_EVENT,
  type MarketingConsent,
  readMarketingConsent,
  saveMarketingConsent,
} from "@/components/analytics/consent";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { Cookie } from "lucide-react";
import { useEffect, useState } from "react";

export function CookieConsent() {
  const [consent, setConsent] = useState<MarketingConsent>(null);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setConsent(readMarketingConsent());
    const update = (event: Event) => {
      setConsent((event as CustomEvent<MarketingConsent>).detail);
    };
    window.addEventListener(MARKETING_CONSENT_EVENT, update);
    return () => window.removeEventListener(MARKETING_CONSENT_EVENT, update);
  }, []);

  const choose = (value: Exclude<MarketingConsent, null>) => {
    saveMarketingConsent(value);
    setConsent(value);
    setEditing(false);
  };

  if (consent && !editing) {
    return (
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="fixed bottom-3 left-3 z-50 rounded-full border bg-background/95 p-2 text-muted-foreground shadow-md backdrop-blur hover:text-foreground"
        aria-label="Çerez tercihlerini değiştir"
        title="Çerez tercihleri"
      >
        <Cookie className="h-4 w-4" />
      </button>
    );
  }

  return (
    <aside className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border bg-background/98 p-4 shadow-2xl backdrop-blur sm:p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <Cookie className="hidden h-7 w-7 shrink-0 text-primary sm:block" />
        <div className="flex-1 space-y-1">
          <h2 className="font-semibold text-sm">Çerez tercihleri</h2>
          <p className="text-muted-foreground text-xs leading-relaxed sm:text-sm">
            Zorunlu çerezler sitenin çalışması için kullanılır. İzin verirseniz
            Google ve Meta ölçüm araçları reklam performansını anlamamıza
            yardımcı olur. Tercihinizi daha sonra değiştirebilirsiniz.{" "}
            <Link
              to="/privacy"
              search={{ tab: "privacy" }}
              className="underline"
            >
              Gizlilik politikası
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-2 sm:flex-col">
          <Button
            size="sm"
            className="flex-1"
            onClick={() => choose("granted")}
          >
            Kabul et
          </Button>
          <Button
            size="sm"
            variant="outline"
            className="flex-1"
            onClick={() => choose("denied")}
          >
            Reddet
          </Button>
        </div>
      </div>
    </aside>
  );
}
